$('table.address.destination td').each(function () {
  if ($(this).text().length > 20) {
    $(this).popover({
      title: $(this).siblings('th').text(),
      content: $(this).text(),
      placement: 'bottom',
    })
  }
})

$('a.phone').popover({
  template:
    '<div class="popover popover-item"><div class="popover-arrow"></div><div class="popover-inner"><div class="popover-content popover-plain"><p></p></div></div></div>',
})

$('a.promotion_balance').popover()
